import { GA_EVENTBRITE } from '../constants/analytics';
import { IAllContextsProps } from '../constants/interfaces';

export const getQuerySourceProvider = ({
    routing,
    contexts,
}: {
    routing: any;
    contexts: IAllContextsProps;
}) => {
    let socialProvider = contexts.userContext?.state.socialProvider ?? '';
    const query = routing?.locationBeforeTransitions?.query ?? '';

    if (query['external_provider'] && query['external_provider'] != 'None') {
        socialProvider = query['external_provider'];
    } else if (!socialProvider) {
        socialProvider = GA_EVENTBRITE;
    }
    return socialProvider;
};
